import { useEffect } from 'react';

// Fires 'pwa_app_launched' once, only when the app is actually running as an
// installed PWA (standalone mode) — not on every regular browser visit.
// Uses the same silent-noop pattern as InstallAppButton's trackPwaEvent:
// only sends the event if analytics already exists in the app (Step 15).
export default function usePwaLaunchTracking() {
  useEffect(() => {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    if (!isStandalone) return;

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'pwa_app_launched');
      } else if (window.analytics && typeof window.analytics.track === 'function') {
        window.analytics.track('pwa_app_launched');
      }
    } catch (e) {
      // Never let analytics failures break app startup.
    }
  }, []);
}